import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"


export default function SelectAlertSubtype({...props}) {

    const getDataAlertSubtype = alertType => {
        const data = {
            'rates': () => {
                return [
                    { label: 'Meta', value: '1' },
                    { label: 'Ota', value: '2' },
                ]
            },
            'availability': () => {
                return [
                    { label: 'Meta', value: '3' },
                    { label: 'Ota', value: '4' },
                ]
            },
            'rate_conditions': () => {
                return null
            }
        }
        
        return data[alertType]()
    }

    const myProps = {
        placeholder: 'All alert subtypes',
        firstSelect: false, isClearable: false, options: getDataAlertSubtype(!isNaN(props.alertType) ? (['1', '2'].some(arrVal => arrVal === props.alertType) ? 'rates' : (['3', '4'].some(arrVal => arrVal === props.alertType) ? 'availability' : props.alertType || 'rates')) : props.alertType),
        icon: {icon: 'calendar-day'}, isMulti: false, isDisabled: !props.alertType, 
        defaultValue: isNaN(props.value) ? (props.value === 'rates' ? '1' : '3') : props.value,
        ...props
    }

    return <SelectSeeker {...myProps} />
}